module.exports = __webpack_public_path__ + "images/emoji/small_red_triangle_down.c423752626d950a15ee5.png";